import { AzureAuth, UserPermissions } from "@app/Components";

export class PersonFunctions {
    public static readonly FCM: string = 'Cabin & Cockpit';
    public static readonly PIC: string = 'PIC';
    public static readonly FO: string = 'FO';
    public static readonly COCKPIT: string = 'Cockpit';
    public static readonly SC: string = 'SC';
    public static readonly CC: string = 'CC';
    public static readonly CABIN: string = 'Cabin';
    public static readonly OBS1: string = 'OBS1';
    public static readonly OBS2: string = 'OBS2';
    public static readonly OPCR: string = 'OPCR';
    public static readonly OGE: string = 'OGE';
    public static readonly OGG: string = 'OGG';
    public static readonly OGGE: string = 'OGGE';
    public static readonly OMCC: string = 'OMCC';
    public static readonly OFC: string = 'OFC';
    public static readonly GROUND: string = 'Ground';
    public static readonly FSE: string = 'Fse';
    public static readonly MARSHALS = "Marshals";
    public static readonly TIG: string = "Tiger";
    public static readonly FFX: string = "Flying Fox";
}

export class PersonFunctionsIds {
    public static readonly PIC: string = '00434950-0000-0000-0000-000000000000';
    public static readonly FO: string = '00004f46-0000-0000-0000-000000000000';
    public static readonly CC: string = '00004343-0000-0000-0000-000000000000';
    public static readonly SC: string = '00004353-0000-0000-0000-000000000000';
    public static readonly OPCR: string = '5243504f-0000-0000-0000-000000000000';
    public static readonly OGE: string = '0045474f-0000-0000-0000-000000000000';
    public static readonly OGG: string = '0047474f-0000-0000-0000-000000000000';
    public static readonly OGGE: string = '4547474f-0000-0000-0000-000000000000';
    public static readonly OMCC: string = '43434d4f-0000-0000-0000-000000000000';
    public static readonly FSE: string = '00455346-0000-0000-0000-000000000000';
    public static readonly TIG: string = '00474954-0000-0000-0000-000000000000';
    public static readonly FFX: string = '00584646-0000-0000-0000-000000000000';
}

export class FunctionGroupIds {
    public static readonly Fcm: string = '004d4346-0000-0000-0000-000000000000';
    public static readonly Cabin: string = '69626143-006e-0000-0000-000000000000';
    public static readonly Cockpit: string = '6b636f43-6970-0074-0000-000000000000';
    public static readonly Ground: string = '756f7247-646e-0000-0000-000000000000';
    public static readonly Fse: string = '00657346-0000-0000-0000-000000000000';
    public static readonly Marshals: string = '7372614d-6168-736c-0000-000000000000';

    public static groupMap: { [functionName: string]: string } = {
        Cockpit: FunctionGroupIds.Cockpit,
        PIC: FunctionGroupIds.Cockpit,
        FO: FunctionGroupIds.Cockpit,
        Cabin: FunctionGroupIds.Cabin,
        SC: FunctionGroupIds.Cabin,
        CC: FunctionGroupIds.Cabin,
        Ground: FunctionGroupIds.Ground,
        OPCR: FunctionGroupIds.Ground,
        OGE: FunctionGroupIds.Ground,
        OGGE: FunctionGroupIds.Ground,
        OMCC: FunctionGroupIds.Ground,
        OFC: FunctionGroupIds.Ground
    };
    public static functionNameMap: { [functionId: string]: string } = {
        [PersonFunctionsIds.PIC]: PersonFunctions.COCKPIT,
        [PersonFunctionsIds.FO]: PersonFunctions.COCKPIT,
        [PersonFunctionsIds.SC]: PersonFunctions.CABIN,
        [PersonFunctionsIds.CC]: PersonFunctions.CABIN,
        [PersonFunctionsIds.OPCR]: PersonFunctions.OPCR,
        [PersonFunctionsIds.OGE]: PersonFunctions.OGE,
        [PersonFunctionsIds.OGG]: PersonFunctions.OGG,
        [PersonFunctionsIds.OGGE]: PersonFunctions.OGGE,
        [PersonFunctionsIds.OMCC]: PersonFunctions.OMCC,
        [PersonFunctionsIds.FSE]: PersonFunctions.FSE,
        [PersonFunctionsIds.TIG]: PersonFunctions.MARSHALS,
        [PersonFunctionsIds.FFX]: PersonFunctions.MARSHALS,
    };
    public static functionGroupNameMap: { [functionGroupId: string]: string } = {
        [FunctionGroupIds.Cockpit]: 'Cockpit',
        [FunctionGroupIds.Cabin]: 'Cabin',
        [FunctionGroupIds.Ground]: 'Ground',
        [FunctionGroupIds.Fse]: 'Fse',
        [FunctionGroupIds.Marshals]: 'Marshals',
    };

    public static groupIdsMap: { [functionId: string]: string } = {
        [PersonFunctionsIds.OPCR]: FunctionGroupIds.Ground,
        [PersonFunctionsIds.OGE]: FunctionGroupIds.Ground,
        [PersonFunctionsIds.OGG]: FunctionGroupIds.Ground,
        [PersonFunctionsIds.OMCC]: FunctionGroupIds.Ground,
        [PersonFunctionsIds.OGGE]: FunctionGroupIds.Ground,
        [PersonFunctionsIds.SC]: FunctionGroupIds.Cabin,
        [PersonFunctionsIds.CC]: FunctionGroupIds.Cabin,
        [PersonFunctionsIds.PIC]: FunctionGroupIds.Cockpit,
        [PersonFunctionsIds.FO]: FunctionGroupIds.Cockpit
    };

    public static cockpitMap: { [functionName: string]: string } = {
        [PersonFunctions.FO]: PersonFunctionsIds.FO,
        [PersonFunctions.PIC]: PersonFunctionsIds.PIC
    };
    public static fcmWithGroupIds: string[] = [FunctionGroupIds.Fcm];
    public static cockpitWithGroupIds: string[] = [PersonFunctionsIds.PIC, PersonFunctionsIds.FO, FunctionGroupIds.Cockpit];
    public static cabinIdWithGroupsIds: string[] = [PersonFunctionsIds.CC, PersonFunctionsIds.SC, FunctionGroupIds.Cabin];
    public static groundWithGroupsIds: string[] = [PersonFunctionsIds.OPCR, PersonFunctionsIds.OGE, PersonFunctionsIds.OGG, PersonFunctionsIds.OGGE, PersonFunctionsIds.OMCC, FunctionGroupIds.Ground];
    public static fseWithGroupsIds: string[] = [PersonFunctionsIds.FSE, FunctionGroupIds.Fse];
    public static marshalsGroupsIds: string[] = [PersonFunctionsIds.TIG, PersonFunctionsIds.FFX];
    public static marshalsWithGroupsIds: string[] = [PersonFunctionsIds.TIG, PersonFunctionsIds.FFX, FunctionGroupIds.Marshals];

    public static groupIds: string[] = [FunctionGroupIds.Cockpit, FunctionGroupIds.Cabin, FunctionGroupIds.Ground];
    public static cockpitIds: string[] = [PersonFunctionsIds.PIC, PersonFunctionsIds.FO];
    public static cabinIds: string[] = [PersonFunctionsIds.CC, PersonFunctionsIds.SC];
    public static groundIds: string[] = [PersonFunctionsIds.OPCR, PersonFunctionsIds.OGE, PersonFunctionsIds.OGG, PersonFunctionsIds.OGGE, PersonFunctionsIds.OMCC];

    public static getAvailableFunctionIds(): string[] {
        const result: string[] = [];
        if (AzureAuth.hasAccess(UserPermissions.RosterCockpitRead)) {
            result.push(FunctionGroupIds.Cockpit, PersonFunctionsIds.FO, PersonFunctionsIds.PIC);
        }
        if (AzureAuth.hasAccess(UserPermissions.RosterCabinRead)) {
            result.push(FunctionGroupIds.Cabin, PersonFunctionsIds.SC, PersonFunctionsIds.CC);
        }
        if (AzureAuth.hasAccess(UserPermissions.RosterCockpitRead) && AzureAuth.hasAccess(UserPermissions.RosterCabinRead)) {
            result.push(FunctionGroupIds.Fcm);
        }
        if (AzureAuth.hasAccess(UserPermissions.RosterGroundRead)) {
            result.push(FunctionGroupIds.Ground, PersonFunctionsIds.OGE, PersonFunctionsIds.OGGE, PersonFunctionsIds.OPCR, PersonFunctionsIds.OMCC);
        }
        if (AzureAuth.hasAccess(UserPermissions.RosterFseRead)) {
            result.push(FunctionGroupIds.Fse);
        }
        if (AzureAuth.hasAccess(UserPermissions.RosterMarshalRead)) {
            result.push(FunctionGroupIds.Marshals, PersonFunctionsIds.FFX, PersonFunctionsIds.TIG);
        }
        return result;
    }

    public static getAvailableFunctionIdsCrewPortal(): string[] {
        const result: string[] = [];
        if (AzureAuth.hasAccess([UserPermissions.CrewPortalCockpitReadOthers])) {
            result.push(FunctionGroupIds.Cockpit, PersonFunctionsIds.FO, PersonFunctionsIds.PIC);
        }
        if (AzureAuth.hasAccess(UserPermissions.CrewPortalCabinReadOthers)) {
            result.push(FunctionGroupIds.Cabin, PersonFunctionsIds.SC, PersonFunctionsIds.CC);
        }
        if (AzureAuth.hasAccess(UserPermissions.CrewPortalGroundReadOthers)) {
            result.push(FunctionGroupIds.Ground, PersonFunctionsIds.OGE, PersonFunctionsIds.OGGE, PersonFunctionsIds.OPCR, PersonFunctionsIds.OMCC);
        }
        return result;
    }
}
